import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { GenericMessage } from './generic-message.interface';
import { WS10HeadlineModel, HeadlineTagEnum } from '@vfde-fe/ngx-lib/brix/ws10-headline';
import { WS10Button } from '@vfde-fe/ngx-lib/brix/ws10-button';
import { ALIGN_CENTER, RECTANGLE_SHAPE, TERTIARY_COLOR } from '../../defines/defines';

/** GenericMessageComponent */
@Component({
  selector: 'generic-message',
  templateUrl: './generic-message.component.html',
})
export class GenericMessageComponent implements OnInit {

  /** messageDetails */
  @Input() public messageDetails: GenericMessage;

  /** headlineConfig */
  public headlineConfig: WS10HeadlineModel;

  /** buttonConfig */
  public buttonConfig: WS10Button;

  /**
   * @param ts TranslateService
   * @param router Router
   */
  public constructor (private router: Router) {}
  /** ngOnInit */
  public ngOnInit (): void {
    this.configureSharedComponents();
  }

  /** configureSharedComponents
   * @method configureSharedComponents to set the configurations for the used ws10 components
   * @returns {void} void
   */
  public configureSharedComponents (): void {
    this.headlineConfig = {
      headingSize: HeadlineTagEnum.H2,
      textContent: this.messageDetails.headline,
      headingAlign: ALIGN_CENTER,
    };
    this.buttonConfig = {
      color: TERTIARY_COLOR,
      shape: RECTANGLE_SHAPE,
      content: this.messageDetails.innerLink ? this.messageDetails.innerLink.text : null,
    };
  }

  /** onButtonClick
   * @method onButtonClick to navigate to another page in the app
   * @returns {void} void
   */
  public onButtonClick (): void {
    const url = [this.messageDetails.innerLink.url];
    this.router.navigate(url);
  }

}
